import TableHeaderSorter from './table-header-sorter';

export default TableHeaderSorter;
